import React, { useMemo } from 'react';
import { useGetLabelByKey, useTranslation } from 'hooks/useLingUI';

import { SportsCacheTemplateAvvenimentoDto } from 'types/swagger';
import classNames from 'classnames';
import { isTruthy } from 'utility/functions';
import styles from './LiveScommessaPreMatch.module.scss';
import { useInfoTemplateAvvenimento } from 'features/sport/hooks';

export type LiveScommessaPreMatchPropsType = {
  className?: string;
};

export const LiveScommessaPreMatch = ({ className }: LiveScommessaPreMatchPropsType) => {
  const quotePreMatchLabel = useGetLabelByKey('quote-pre-match');
  const { t } = useTranslation();

  const { templateAvvenimento } = useInfoTemplateAvvenimento<SportsCacheTemplateAvvenimentoDto>();

  const { key, headers, headersTrKey, descrizione, descrizioneTrKey, quotaList } = useMemo(() => {
    const { live, key } = templateAvvenimento ?? {};
    const { headers, headersTrKey, descrizione, descrizioneTrKey, quotaList } = live?.scommessaPreMatch ?? {};

    return { key, headers, headersTrKey, descrizione, descrizioneTrKey, quotaList };
  }, [templateAvvenimento]);

  if (isTruthy(headers?.length)) {
    return (
      <div
        key={`LiveScommessaPreMatch-${key}`}
        className={classNames(styles.wrapper, className ?? '')}
        suppressHydrationWarning
      >
        <span className={styles.description}>{quotePreMatchLabel}</span>
        <div className={styles.container}>
          <p className={styles.title}>{t(descrizioneTrKey, descrizione)}</p>

          <div className={styles.quoteContainer}>
            {headers?.map((header, index) => {
              const headerTrKey = headersTrKey && headersTrKey[index];
              return (
                <div className={styles.quotaBox} key={`${header}_${index}`}>
                  <span className={styles.titleScommessa}>{t(headerTrKey, header)}</span>
                  <span className={styles.quota}>{quotaList?.[index]}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return <React.Fragment key={`LiveScommessaPreMatch-${key}`} />;
};
